import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function Testimonial() {
  const [index, setIndex] = useState(0);
  const t = testimonials[index];

  const goPrev = () => {
    setIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const goNext = () => {
    setIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-sm font-heading italic text-accent-600 tracking-wide mb-8">
          ( What Users Say )
        </p>

        <div className="relative">
          <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-foreground-900 text-white text-sm mb-6">
            <i className="ri-star-fill text-amber-400 text-sm"></i>
            <span className="font-semibold">{t.rating}/5</span>
          </div>

          <blockquote className="text-lg md:text-xl font-testimonial italic text-foreground-800 leading-relaxed mb-8 text-balance">
            &ldquo;{t.quote}&rdquo;
          </blockquote>

          <div className="flex items-center justify-center gap-3">
            <img
              src={t.avatar}
              alt={t.name + " pandabuy spreadsheet user review"}
              title={t.name + " - PandaBuy Spreadsheet Review"}
              className="w-12 h-12 rounded-full object-cover"
              loading="lazy"
            />
            <div className="text-left">
              <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
              <p className="text-xs text-foreground-500">{t.handle}</p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mt-8">
            <button
              onClick={goPrev}
              className="w-9 h-9 rounded-full border border-background-300 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-s-line text-foreground-600"></i>
            </button>
            <button
              onClick={goNext}
              className="w-9 h-9 rounded-full bg-foreground-900 flex items-center justify-center hover:bg-foreground-800 transition-colors cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-s-line text-white"></i>
            </button>
          </div>

          <div className="flex items-center justify-center gap-1.5 mt-4">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  i === index ? "bg-foreground-900 w-5" : "bg-background-300"
                }`}
                aria-label={`Go to testimonial ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}